/**
 * Created by Markus on 15.6.2015.
 * In this case sections are considered the level 1 pages that have children (1 or more)
 */

define('helperNavigation-getSectionNId',['helperContent-getSectionEntities'], function(getSectionEntities) {
    'use strict';

    var getSectionNID = function(sectionNumber, arr) {

        sectionNumber = sectionNumber || -1;

        var sections,
            section;

        if (sectionNumber === -1 || !Array.isArray(arr)) {
            return null;
        }

        arr = [].concat(arr);

        sections = getSectionEntities(arr);

        if (!sections || !Array.isArray(sections) || !sections.length) {
            return null;
        }

        section = sections[sectionNumber-1];

        if (!section) {
            return null;
        }

        return (section.hasOwnProperty('contentEntityId')) ? section.contentEntityId : null;
    };

    return getSectionNID;

});

